import { Component } from '@angular/core';

@Component({
  selector: 'app-successful-submission',
  standalone: true,
  imports: [],
  templateUrl: './successful-submission.component.html',
  styleUrl: './successful-submission.component.scss'
})
export class SuccessfulSubmissionComponent {

}
